import { createAction } from '@reduxjs/toolkit'
import { FiltreOrgansType } from 'store/reducers/FiltreOrgansReducer'

export const resetFiltreOrgans = createAction('resetFiltreOrgans')
export const setFiltreOrgans = createAction<FiltreOrgansType>('setFiltreOrgans')
